import { useRootSelector } from "@modules/store/redux"

export const useContactInfo = (uid?: string) => {
  const { contacts } = useRootSelector((state) => state.contacts)

  return {
    contact: uid ? contacts[uid] : undefined,
  }
}
